






















































import { Component, Vue } from 'vue-property-decorator';
import { WTs } from '@service/solr/model';
import QueryForm from '@components/collection/QueryForm';

@Component
export default class QueryFormPanel extends Vue {
  private wts = WTs;
  private queryForm: QueryForm = {
    qt: '/select',
    q: '*:*',
    start: 0,
    rows: 10,
    wt: this.wts[0],
    facet: {
      query: '',
      field: '',
      prefix: '',
    },
  };
  private querying = false;

  private facet = false;

  private submit() {
    const queryForm = Object.assign({}, this.queryForm);

    if (!this.facet) {
      delete queryForm.facet;
    }

    this.$emit('query', queryForm);
  }
}
